import type { TechMeansWithRecommend } from './types';

export interface ApiGetTechMeansRequest {
    task_id: string;
    current_step: string;
    input: string;
}

export type ApiGetTechMeansResponse = TechMeansWithRecommend;

export const GetTechMeans = Symbol('GetTechMeans');

export interface GetTechMeans {
    getTechMeans(data: ApiGetTechMeansRequest): Promise<ApiGetTechMeansResponse>;
}
